<div class="modal-header">
    <h2 class="modal-title">New projects found in Jira</h2>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss()">
        <span aria-hidden="true">&times;</span>
    </button>
</div>

<div class="modal-body">
    <div *ngIf="!missingProjects?.length" class="hint">No new projects found in Jira.</div>

    <div *ngIf="missingProjects?.length" class="table__overflow">
        <table class="table-view">
            <tr>
                <th>Project name</th>
                <th>Jira key</th>
                <th class="text-right">Action</th>
            </tr>
            <tr *ngFor="let project of missingProjects">
                <td>{{ project.projectName || 'Unnamed project' }}</td>
                <td>{{ project.projectKey }}</td>
                <td class="text-right">
                    <button
                        type="button"
                        class="button button--primary button--small"
                        [disabled]="isCreating(project.projectKey)"
                        (click)="addProjectFromJira(project)">
                        <span *ngIf="!isCreating(project.projectKey)">Add project</span>
                        <span *ngIf="isCreating(project.projectKey)">Adding…</span>
                    </button>
                </td>
            </tr>
        </table>
    </div>
</div>

<div class="modal-footer">
    <button type="button" class="button button--outline" (click)="activeModal.dismiss()">Close</button>
</div>
